import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import Heading from '@/shared-components/text/components/Heading';

import './styles/ProfileOptionsPageHeader.css';

export default function ProfileOptionsPageHeader({ title, onBack, action = null }) {
  return (
    <header className="profile-options-page-header">
      <button
        type="button"
        className="profile-options-page-header__back-button"
        onClick={onBack}
        aria-label="Go back"
      >
        <BackArrowIcon className="profile-options-page-header__back-icon" />
      </button>
      <Heading className="profile-options-page-header__title">{title}</Heading>
      <div className="profile-options-page-header__action">{action}</div>
    </header>
  );
}
